var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShipping({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "52471BD3-5650-4707-843A-D230DCC3731C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PDP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-PDP-schedule",
    transform: "translate(-1321.000000, -752.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Right-info",
    transform: "translate(992.000000, 216.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F5F5F5",
    x: 5.68434189e-14,
    y: 288,
    width: 592,
    height: 392
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#CCCCCC",
    x: 0.5,
    y: 0.5,
    width: 591,
    height: 775,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shipment",
    transform: "translate(56.000000, 416.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Your-subscription",
    transform: "translate(256.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    fill: "#38291E",
    x: 0,
    y: 0,
    width: 200,
    height: 152,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon/Plus",
    transform: "translate(17.000000, 120.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7500001,4.53125002 C14.0029998,4.53125002 14.2091854,4.73168556 14.2184268,4.98242672 L14.21825,5.78125002 L17.0768548,5.78125003 C17.47937,5.78125003 17.8453883,6.0018048 18.0356543,6.34863393 L18.0923759,6.46879114 L19.1830392,9.19522639 C19.2039225,9.24547322 19.2163153,9.3001369 19.2184268,9.35742674 L19.2187501,14.3750001 C19.2187501,14.9708985 18.7422069,15.4554944 18.1494255,15.4684827 L16.9844358,15.4684089 C16.7674097,16.538379 15.8215071,17.3437501 14.6875001,17.3437501 C13.5760989,17.3437501 12.6453775,16.5701684 12.4044079,15.5320773 L7.59559218,15.5320773 C7.35462265,16.5701684 6.42390118,17.3437501 5.31250003,17.3437501 C4.17849296,17.3437501 3.23259039,16.538379 3.01556428,15.4684089 L1.87500001,15.4687501 C1.27910155,15.4687501 0.794505716,14.9922069 0.781517351,14.3994255 L0.781250004,5.62500003 C0.781250004,5.02910157 1.25779316,4.54450573 1.85057462,4.53151737 L13.7500001,4.53125002 Z M14.6875001,13.5937501 C13.9108496,13.5937501 13.2812501,14.2233496 13.2812501,15.0000001 C13.2812501,15.7766505 13.9108496,16.4062501 14.6875001,16.4062501 C15.4641505,16.4062501 16.0937501,15.7766505 16.0937501,15.0000001 C16.0937501,14.2233496 15.4641505,13.5937501 14.6875001,13.5937501 Z M5.31250003,13.5937501 C4.53584959,13.5937501 3.90625002,14.2233496 3.90625002,15.0000001 C3.90625002,15.7766505 4.53584959,16.4062501 5.31250003,16.4062501 C6.08915046,16.4062501 6.71875003,15.7766505 6.71875003,15.0000001 C6.71875003,14.2233496 6.08915046,13.5937501 5.31250003,13.5937501 Z M18.2812501,9.84375005 L14.21825,9.84325002 L14.2190912,12.7030643 C14.3195548,12.6826869 14.4223512,12.6687353 14.5270326,12.6616572 L14.6875001,12.6562501 C15.8215162,12.6562501 16.7674248,13.461634 16.984441,14.5316168 L18.1250001,14.5312501 C18.2073721,14.5312501 18.2748567,14.4675096 18.2808215,14.3866612 L18.2812501,14.3750001 L18.2812501,9.84375005 Z M13.28125,11.78125 L1.71825,11.78125 L1.71875001,14.3750001 C1.71875001,14.4573721 1.78249046,14.5248567 1.86333889,14.5308215 L1.87500001,14.53125 L3.01555909,14.5316168 C3.23257531,13.461634 4.17848393,12.6562501 5.31250003,12.6562501 C6.44651613,12.6562501 7.39242474,13.461634 7.60944096,14.5316168 L12.3905591,14.5316168 C12.5065798,13.9595854 12.8309293,13.4631806 13.2809747,13.1250353 L13.28125,11.78125 Z M13.28125,5.46875003 L1.87500001,5.46875003 C1.79262799,5.46875003 1.72514336,5.53249048 1.71917858,5.61333891 L1.71825,10.78125 L13.28125,10.78125 L13.28125,5.46875003 Z M17.0768548,6.71875003 L14.2187501,6.71875003 L14.2187501,8.90625004 L18.0576563,8.90625004 L17.2219291,6.81697015 C17.1997823,6.76160334 17.1482567,6.72402727 17.0895391,6.71926321 L17.0895391,6.71926321 L17.0768548,6.71875003 Z",
    id: "Combined-Shape"
  })))))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.49925424.svg";
export { ForwardRef as ReactComponent };